import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export interface MotivoNegacaoLead {
  id: string;
  titulo: string;
  ordem: number;
  ativo: boolean;
}

const CHAVE = ["motivos-negacao-lead"];

export function useMotivosNegacaoLead() {
  return useQuery({
    queryKey: CHAVE,
    staleTime: 60_000,
    queryFn: async (): Promise<MotivoNegacaoLead[]> => {
      const { data, error } = await supabase
        .from("motivos_negacao_lead")
        .select("id, titulo, ordem, ativo")
        .order("ordem", { ascending: true });
      if (error) throw error;
      return (data || []) as MotivoNegacaoLead[];
    },
  });
}

export function useSalvarMotivoNegacaoLead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (m: Partial<MotivoNegacaoLead> & { titulo?: string }) => {
      const payload = { ...m, updated_at: new Date().toISOString() };
      const { error } = m.id
        ? await supabase.from("motivos_negacao_lead").update(payload).eq("id", m.id)
        : await supabase.from("motivos_negacao_lead").insert({ titulo: m.titulo as string, ordem: m.ordem ?? 0 });
      if (error) throw error;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: CHAVE }),
    onError: (e: Error) => toast.error("Não foi possível salvar o motivo", { description: e.message }),
  });
}

export function useExcluirMotivoNegacaoLead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const { error } = await supabase.from("motivos_negacao_lead").delete().eq("id", id);
      if (error) throw error;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: CHAVE }),
    onError: (e: Error) => toast.error("Não foi possível excluir o motivo", { description: e.message }),
  });
}
